import React from 'react'
import { useTicketDetail } from '../hooks/useTicketDetail'
import TicketDetail from './TicketDetail'

export default function TicketContent({ data, inDialog = false }) {
  const vm = useTicketDetail({ source: 'inbox' })
  return <TicketDetail data={data} inDialog={inDialog} {...vm} />
}
